export const environment = {
  production: false,
  projectBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/projectsvc/',
  offerBaseURL: 'https://blueprint-d.dnaofsafety.net/api/offersvc',
  offerLibraryBaseURL: 'https://blueprint-d.dnaofsafety.net/api/offersvc/librarysvc',
  masterMachineSvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/offersvc/mastermachinesvc',
  customerBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/customersvc',
  orderBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/ordersvc/',
  bucketSvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/bucketsvc/',
  bucketMachineSvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/bucketmachinesvc/',
  libraryBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/librarysvc/',
  libraryMastermachineSvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/librarysvc/mastermachinesvc/',
  libraryRoadmapSvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/librarysvc/roadmapsvc/',
  sopLibraryBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/soplibrarysvc',
  notificationBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/notificationsvc/',
  riskassessmentBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/riskassessmentsvc/',
  userGroupBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/group/',
  userBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/',
  opportunitysvcBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/offersvc/opportunitysvc',
  tokenEndpoint: 'https://blueprint-d.dnaofsafety.net',
  tokenScopes: ['api://b73ff917-9865-437e-aab8-43cc2f5c9317/.default'],
  msaAuthClientId: '96bd14ea-3d34-43c5-8a9d-6ec1f2282c04',
  riskAssessmentBaseUrl: 'https://schriskassessmentdev.azurewebsites.net/api/',
  // userMangBaseUrl: "https://schuserservice.azurewebsites.net",
  newOfferBaseUrl: 'https://offerapiservicedev.azurewebsites.net/',
  fourEyeQualityBaseUrl: 'https://blueprint-d.dnaofsafety.net/api/foureyesqualitysvc/',
  // updateOpportunityBaseURL: 'https://blueprint-d.dnaofsafety.net/api/offersvc/',
  profileBookmarkData: 'https://blueprint-d.dnaofsafety.net/api/user/',
  azureSearchKey:'d3KmxPeBdd0guITBdAI8GT9tAGrwE9C7migYU9sArGAzSeCRLDA1',


  commincationSiteName: 'Blueprint',
  commincationSiteFolderPath: '/Templates/Offer_Templates',
  workflows: 'https://blueprint-d.dnaofsafety.net/api/workflows/',
  userPrincipleName: 'blueprint.logicapp@dnaofsafetydev.onmicrosoft.com',
  azureSearch: 'https://dna-srch-westeurman-qa.search.windows.net/',
  launchFiory: 'https://sq2d.kas-sap.net/sap/bc/ui2/flp?companyCode=',
  projectSvc: 'https://blueprint-q.dnaofsafety.net/api/projectsvc/service/',

  // Root URL of the `blueprint` Next.js app — hosts the AI writing-assist routes
  // (proofread/rewrite/generate) under /api/ai-writing/*.
  aiWritingBaseUrl: 'http://localhost:3000',
  aiAssistantUrl: 'https://ai.dnaofsafety.net/',

  // Master switch for AI features (assistant widget, writing assist, etc.).
};
